import { CardContent, Grid } from "@mui/material";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../../actions/login";
import Logo from "../../../assets/images/logo_medium.png";
import { StyledLoginContainer } from "../../styled/login";
import LoginFooter from "../login/loginFooter";
import LoginForm from "./LoginForm";
import MFAForm from "./mfa/mfaForm";

const LoginContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const captchaRef = useRef(null);
  const loading = useSelector((state) => state.auth.isFetching);
  const blockPasswordReset = useSelector((state) => state.auth.blockPasswordReset);
  const [displayMFALogin, setDisplayMFALogin] = useState(false);
  const [credentials, setCredentials] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const [lastCodeExpirationTime, setLastCodeExpirationTime] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmitUser = (values) => {
    dispatch(loginUser(values, values.userName))
      .then((res) => {
        // Caso MFA
        if (!res?.payload?.token) {
          setCredentials(values)
          setDisplayMFALogin(true);
          if (res?.value?.mfAexpirationTime) {
            setLastCodeExpirationTime(res?.value?.mfAexpirationTime);
          }
          return;
        }
        // Caso exitoso sin MFA
        navigate("/home")
      })
      .catch((error) => {
        captchaRef.current?.reset();
      });
  };



  return (
    <StyledLoginContainer.GridContainer container>
      <StyledLoginContainer.LoginCard>
        <CardContent>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="column">
            <StyledLoginContainer.LogoImage src={Logo} alt="" />
          </Grid>
          {displayMFALogin
            ? <MFAForm
              credentials={credentials}
              handleCancel={() => setDisplayMFALogin(false)}
              lastCodeExpirationTime={lastCodeExpirationTime}
            />

            : <LoginForm
              handleSubmit={handleSubmitUser}
              loading={loading}
              captchaRef={captchaRef}
              showPassword={showPassword}
              togglePasswordVisibility={togglePasswordVisibility}
            />
          }
        </CardContent>
        {!displayMFALogin && <LoginFooter register passwordRecovery={!blockPasswordReset}></LoginFooter>}
      </StyledLoginContainer.LoginCard>

    </StyledLoginContainer.GridContainer>
  );
};

export default LoginContainer;
